import React, {useRef, useState, useEffect} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField, useFormikContext} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, TextArea, NewsletterSignupInput} from "@components/Form/FormFields";


const NewsletterSignup = ({useGoogleRecaptcha,...props}) => {
   
    const captchaRef = useRef();
    const thankYouRef = useRef();
    const [loadCaptcha, setCaptchaLoaded] = useState(false);
    const [formAccepted, setFormAccepted] = useState(false);
    useEffect(() => {
        if (formAccepted) {
            thankYouRef.current.scrollIntoView();
        }
    }, [formAccepted])

    const onSubmitWithReCAPTCHA = async (values, {setSubmitting, resetForm}) => {
        //console.log("SUBMIT!");
        let recaptcha = null;
        if(useGoogleRecaptcha){
            recaptcha = await captchaRef.current.executeAsync();       
        }
     
        //
        // // if (token) {
        // //     setCaptchaVerified(true);
        // // }
        //
        props.berikssonStore.newsletterSignup({...values, recaptcha}).then(res => {
             setSubmitting(false);
             setFormAccepted(true);
        }, (error) => {
            if(useGoogleRecaptcha) {
                captchaRef.current.reset();
            }
            //console.log("error", error);
            setSubmitting(false);
        });
    //     alert(JSON.stringify(values, null, 2));
    //     setFormAccepted(true);
    }


    return (
        <React.Fragment>

            {formAccepted
                ? <div className={"newsletter-signup-form"} ref={thankYouRef}>{props.thankYouMessage}</div>
                :
                <Formik
                    validateOnMount={true}
                    initialValues={{
                        cultureCode: props.cultureCode,
                        nodeId: props.nodeId,
                        recaptcha: '',
                        //name: '',
                        signup: '',

                        consent: false
                    }}
                    validationSchema={Yup.object({
                        //recaptcha: Yup.string().required(),

                        // name: Yup.string()
                        //     .required('Måste anges'),
                        signup: Yup.string()
                            .email('Ogiltig epostadress')
                            .required('Måste anges'),


                    })}
                    onSubmit={onSubmitWithReCAPTCHA}
                >
                    {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid, touched, handleChange}) => {

                  //      const { submitForm } = useFormikContext();
                        //  noValidate
                        const handleFieldBlur = (e) => {
                            // console.log("$$$$", isSubmitting);
                            // if (!values.recaptcha) {
                            //     captchaRef.current.execute();
                            //     setSubmitting(true);
                            // }
                            // handleBlur(e);
                        }

                        const handleFocus = (e) => {
                            //console.log("handleFocus!")
                            setCaptchaLoaded(true);
                        }


                        return <Form autoComplete={"off"} className={(Object.keys(touched).length > 0 ? "touched" : "") + " newsletter-signup-form"}>

                            <NewsletterSignupInput
                                label={props.submitButtonText}
                                name="signup"
                                type="text"
                                onFocus={handleFocus}
                                placeholder={props.placeHolder}
                                
                                //onBlur={handleFieldBlur}
                                //placeholder="Doe"
                            />

                            {/*<button className="btn btn-success"*/}
                            {/*type="submit"*/}
                            {/*disabled={isSubmitting || !isValid}>Skicka*</button>*/}


                            {/*<div className={"col-12"}>*/}
                            {/*    <TextArea*/}
                            {/*        label="Meddelande"*/}
                            {/*        name="message"*/}
                            {/*        type="text"*/}
                            {/*        //onBlur={handleFieldBlur}*/}
                            {/*        //placeholder="Doe"*/}
                            {/*    />*/}
                            {/*</div>*/}

                            {useGoogleRecaptcha && loadCaptcha && <React.Fragment>
                                <ReCAPTCHA
                                    ref={captchaRef}
                                    sitekey={props.recaptchaV2Key}
                                    onChange={(value) => {
                                        //console.log("$$$$onChange", value);
                                        //setFieldValue("recaptcha", value);
                                        setSubmitting(false);
                                    }}
                                    // onExpired={(value) => {
                                    //     console.log("$$$$onExpired", value);
                                    //     setFieldValue("memberConsent", false);
                                    // }}
                                    size="invisible"
                                />
                                {/*<CheckboxInput*/}
                                {/*    id="consent"*/}
                                {/*    label="Medgivande"*/}
                                {/*    name="consent"*/}
                                {/*    onBlur={handleFieldBlur}*/}
                                {/*>*/}
                                {/*    Ja, jag ger mitt medgivande till att spara och hantera den data jag angivit ovan.*/}
                                {/*</CheckboxInput>*/}


                                <div className={"reCaptchaInfo"}>
                                    This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy
                                    Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                                </div>
                                 
                            </React.Fragment>}


                            {/*</div>*/}


                            {/*<div className={"row"}>*/}
                            {/*    <div className={"col-12 "}>*/}
                            {/*        <button className="btn btn-success"*/}
                            {/*                type="submit"*/}
                            {/*                disabled={isSubmitting || !isValid}>Skicka*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                        </Form>
                    }
                    }
                </Formik>}
        </React.Fragment>
    );
};

@inject("store")
@observer
export default class DoctypeNewsletterSignup extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //var content = this.props
        return (<NewsletterSignup
            recaptchaV2Key={this.props.store.navigation.recaptchaV2Key}
            berikssonStore={this.props.store.beriksson}
            nodeId={this.props.store.navigation.NodeId}
            cultureCode={this.props.store.navigation.CultureCode}
            useRecaptcha={this.props.model.useGoogleRecaptcha}
            submitButtonText={this.props.model.submitButtonText}
            thankYouMessage={this.props.model.thankYouMessage}
            placeHolder={this.props.model.placeHolder}
        />);
    }
}